const BASE_URL = process.env.REACT_APP_BASE_URL;

// ---------- Video APIs ----------

export const startVideo = async (publicationId, token) => {
    try {
      const response = await fetch(
         `${BASE_URL}/start-video/`,
        
        {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${token}`,
        },
        body: new URLSearchParams({ publicationId }),
      });
      if (!response.ok) {
        // Check for 500 error specifically
        if (response.status === 500) {
          return { error: "Oops! Something went wrong on our end." };
        }
        const errorResponse = await response.json();
        console.error("Error starting video generation:", errorResponse);
        return { error: "Failed to start video generation. Please try again." };
      }
      return await response.json();
    } catch (error) {
      console.error("Error in startVideo:", error);
      return { error: "Failed to start video generation. Please try again." };
    }
  };
  
 
  export const fetchVideo = async (videoId, token) => {
    try {
      // Use HEAD request to check if video exists without downloading the full content
      const response = await fetch(`${BASE_URL}/video/${videoId}`,  
       {
        method: "HEAD",
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.ok) {
        return `${BASE_URL}/video/${videoId}`;
      } else {
        return { error: "Failed to load video file." };
      }
    } catch (error) {
      console.error("Error fetching video:", error);
      return { error: "An unexpected error occurred while fetching the video." };
    }
  };
  
  // ---------- PPT APIs ----------
  export const startPPT = async (publicationId, token,contentLevel) => {
    try {
      const response = await fetch(`${BASE_URL}/start-ppt`,
        {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${token}`,
        },
        body: new URLSearchParams({ publicationId,contentLevel }),
      });

      if (!response.ok) {
        // Check for 500 error specifically
        if (response.status === 500) {
          return { error: "Oops! Something went wrong on our end." };
        }
        const errorResponse = await response.json();
        console.error("Error starting PPT generation:", errorResponse);
        return { error: "Failed to start PPT generation. Please try again." };
      }
      return await response.json();
    } catch (error) {
      console.error("Error in startPPT:", error);
      return { error: "An unexpected error occurred while starting PPT generation." };
    }
  };
  
  
  export const fetchPPT = async (pptId, token) => {
    try {
      const response = await fetch(`${BASE_URL}/ppt/${pptId}`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.ok) {
        return `${BASE_URL}/ppt/${pptId}`;
      } else {
        console.error("Failed to load PPT file, status:", response.status);
      return { error: "Failed to load PPT file." };
      }
    } catch (error) {
      console.error("Error fetching PPT:", error);
    return { error: "An unexpected error occurred while fetching the PPT." };
    }
  };

//   export const fetchPPT = async (pptId, token) => {
//   try {
//     const response = await fetch(`${BASE_URL}/ppt/${pptId}?json=true`, {
//       method: "GET",
//       headers: { 
//         Authorization: `Bearer ${token}`,
//         Accept: "application/json"
//       },
//     });
//     if (response.ok) {
//       const data = await response.json();
//       return data.ppt_url; // This is the tunnel URL
//     } else {
//       console.error("Failed to load PPT file, status:", response.status);
//       return { error: "Failed to load PPT file." };
//     }
//   } catch (error) {
//     console.error("Error fetching PPT:", error);
//     return { error: "An unexpected error occurred while fetching the PPT." };
//   }
// };
  
  // ---------- Poster APIs ----------
  export const startPoster = async (publicationId, token, posterContentLevel, posterId = null) => {
    try {
      const bodyParams = { publicationId, professional_type: posterContentLevel };
      if (posterId) bodyParams.posterId = posterId;

      const response = await fetch(`${BASE_URL}/start-poster`,
        {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${token}`,
        },
        body: new URLSearchParams(bodyParams),
      });
      if (!response.ok) {
        // Check for 500 error specifically
        if (response.status === 500) {
          return { error: "Oops! Something went wrong on our end." };
        }
        const errorResponse = await response.json();
        console.error("Error starting poster generation:", errorResponse);
        return { error: "Failed to start Poster generation. Please try again." };
      }
      return await response.json();
    } catch (error) {
      console.error("Error in startPoster:", error);
      return { error: "An unexpected error occurred while starting Poster generation." };
    }
  };
  
  export const fetchPoster = async (posterId, token) => {
    try {
      const response = await fetch(`${BASE_URL}/poster/${posterId}`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.ok) {
        return `${BASE_URL}/poster/${posterId}`;
      } else {
        console.error("Failed to load poster file, status:", response.status);
      return { error: "Failed to load poster file." };
      }
    } catch (error) {
      console.error("Error fetching poster:", error);
      return { error: "An unexpected error occurred while fetching the poster." };
    }
  };
  
  // ---------- Audio APIs ----------
  export const startAudio = async (publicationId, token, audioParams, audioId = null) => {
    try {
      const bodyParams = { publicationId, ...audioParams };
      if (audioId) bodyParams.audioId = audioId;

      const response = await fetch(`${BASE_URL}/start-audio`,
        {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${token}`,
        },
        body: new URLSearchParams(bodyParams),
      });
      if (!response.ok) {
        // Check for 500 error specifically
        if (response.status === 500) {
          return { error: "Oops! Something went wrong on our end." };
        }
        const errorResponse = await response.json();
        console.error("Error starting audio generation:", errorResponse);
        return { error: "Failed to start Audio Summary generation. Please try again." };
      }
      return await response.json();
    } catch (error) {
      console.error("Error in startAudio:", error);
      return { error: "An unexpected error occurred while starting Audio Summary generation." };
    }
  };
  
  
  export const fetchAudio = async (audioId, token) => {
    try {
      const response = await fetch(`${BASE_URL}/audio/${audioId}`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.ok) {
        return `${BASE_URL}/audio/${audioId}`;
      const data = await response.json();
      // // return data.audioData;  
      //      // Check if audioData exists and is a string
      //      console.log("Audio data received:", data);
      // if (data && typeof data.audioData === 'string') {
      //   return data.audioData;}
      }
       else {
        console.error("Failed to load audio file, status:", response.status);
      return { error: "Failed to load audio file." };
      }
    } catch (error) {
      console.error("Error fetching audio:", error);
    return { error: "An unexpected error occurred while fetching the audio." };
    }
  };
  
  // ---------- Download Helpers ----------
  export const downloadAsset = (downloadUrl, fileName) => {
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  
  export const downloadVideo = async (videoId, token) => {
    try {
        const response = await fetch(`${BASE_URL}/video/download/${videoId}`, {
            method: 'GET',
            headers: { Authorization: `Bearer ${token}` },
        });
        if (!response.ok) 
        {
          console.error("Failed to download  video, status:", response.status);
          return { error: "Failed to download video file." };
        }
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = "abstract_video.mp4";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error("Error downloading video:", error);
    }
};
  
  export const downloadPPT = async (pptId, token) => {
    try {
        const response = await fetch(`${BASE_URL}/ppt/download/${pptId}`, {
            method: 'GET',
            headers: { Authorization: `Bearer ${token}` },
        });
        if (!response.ok) {
          console.error("Failed to download PPT file, status:", response.status);
      return { error: "Failed to download PPT file." };
        }
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = "presentation.pptx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error("Error downloading PPT:", error);
    }
};
  
  export const downloadPoster = async (posterId, token) => {
    try {
        const response = await fetch(`${BASE_URL}/poster/download/${posterId}`, {
            method: 'GET',
            headers: { Authorization: `Bearer ${token}` },
        });
        if (!response.ok)  {
          console.error("Failed to download Poster file, status:", response.status);
      return { error: "Failed to download Poster file." };
        }
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = "poster.pptx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error("Error downloading poster:", error);
    }
};

  
  export const downloadAudio = async (audioId, token) => {
    try {
        const response = await fetch(`${BASE_URL}/audio/download/${audioId}`, {
            method: 'GET',
            headers: { Authorization: `Bearer ${token}` },
        });
        if (!response.ok) {
          console.error("Failed to download audio file, status:", response.status);
      return { error: "Failed to download audio file." };
        }
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = "audio_summary.mp3";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error("Error downloading audio:", error);
    }
};
  
  // ---------- Images (Figures) APIs ----------

  export const startImages = async (publicationId, token) => {
    try {
      const response = await fetch(`${BASE_URL}/start-images/`,
       {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${token}`,
        },
        body: new URLSearchParams({ publicationId }),
      });
      if (!response.ok) {
        // Check for 500 error specifically
        if (response.status === 500) {
          return { error: "Oops! Something went wrong on our end." };
        }
        const errorResponse = await response.json();
        console.error("Error starting images generation:", errorResponse);
        return { error: "Failed to start images generation. Please try again." };
      }
      return await response.json();
    } catch (error) {
      console.error("Error in startImages:", error);
      return { error: "An unexpected error occurred while starting Image generation." };
    }
  };
  
  
  // Fetch Images
  export const fetchImages = async (fileId, token) => {
    try {
      const response = await fetch(`${BASE_URL}/image/${fileId}`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.ok) {
        const data = await response.json();
        if (!data?.merged_images) {
          console.error("Expected merged_images not found in response:", data);
          return { error: "Failed to load images: merged images not found." };
        }
        return data.merged_images;
      } else {
        console.error("Failed to load images, status:", response.status);
      return { error: "Failed to load images." };
      }
    } catch (error) {
      console.error("Error fetching images:", error);
    return { error: "An unexpected error occurred while fetching images." };
    }
  };
  

export const downloadImages = async (imageId, token) => {
  try {
      const response = await fetch(`${BASE_URL}/Image/download/${imageId}`, {
          method: 'GET',
          headers: { Authorization: `Bearer ${token}` },
      });
      if (!response.ok) {
        console.error("Failed to download images, status:", response.status);
      return { error: "Failed to download images." };
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `images.zip`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
  } catch (error) {
      console.error("Error downloading images:", error);
  }
};

  // ---------- Carousel APIs ----------

 
export const startCarousel = async (publicationId, token) => {
    try {
      const response = await fetch(`${BASE_URL}/start-carousel/`,
        {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${token}`,
        },
        body: new URLSearchParams({ publicationId }),
      });
      if (!response.ok) {
        // Check for 500 error specifically
        if (response.status === 500) {
          return { error: "Oops! Something went wrong on our end." };
        }
        const errorResponse = await response.json();
        console.error("Error starting carousel generation:", errorResponse);
        return { error: "Failed to start Carousel generation. Please try again." };
      }
      return await response.json();
    } catch (error) {
      console.error("Error in startCarousel:", error);
      return { error: "An unexpected error occurred while starting Carousel generation." };
    }
  };
  
   
  // Fetch Carousel
  export const fetchCarousel = async (carouselId, token) => {
    try {
      const response = await fetch(`${BASE_URL}/carousel/${carouselId}`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.ok) {
        return `${BASE_URL}/carousel/${carouselId}`;
      } else {
        console.error("Failed to load carousel file, status:", response.status);
      return { error: "Failed to load carousel file." };
      }
    } catch (error) {
      console.error("Error fetching carousel:", error);
    return { error: "An unexpected error occurred while fetching the carousel." };
    }
  };
  
 
  export const downloadCarousel = async (carouselId, token) => {
    try {
        const response = await fetch(`${BASE_URL}/carousel/download/${carouselId}`, {
            method: 'GET',
            headers: { Authorization: `Bearer ${token}` },
        });
        if (!response.ok) {
          console.error("Failed to download carousel file, status:", response.status);
          return { error: "Failed to download carousel file." };
        }
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = "carousel.pptx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error("Error downloading carousel:", error);
    }
};



 

// Start Instapost Generation

export const startInstapost = async (publicationId, token, { uploadedType }) => {
  try {
    const params = new URLSearchParams({ publicationId, uploadedType });
    const response = await fetch(`${BASE_URL}/start-Instapost/`,
      {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${token}`,
      },
      body: params,
    });
    if (!response.ok) {
      // Check for 500 error specifically
      if (response.status === 500) {
        return { error: "Oops! Something went wrong on our end." };
      }
      const errorResponse = await response.json();
      console.error("Error starting instapost generation:", errorResponse);
      return { error: "Failed to start Post generation. Please try again." };
    }
    return await response.json();
  } catch (error) {
    console.error("Error in startInstapost:", error);
    return { error: "An unexpected error occurred while starting Post generation." };
  }
};

  
   
  
  // Fetch Instapost
  export const fetchInstapost = async (instaId, token) => {
    try {
      const response = await fetch(`${BASE_URL}/Instapost/${instaId}`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.ok) {
        return `${BASE_URL}/Instapost/${instaId}`;
      } else {
        console.error("Failed to load instapost file, status:", response.status);
      return { error: "Failed to load instapost file." };
      }
    } catch (error) {
      console.error("Error fetching instapost:", error);
    return { error: "An unexpected error occurred while fetching the instapost." };
    }
  };
  

  export const downloadInstapost = async (instaId, token) => {
    try {
        const response = await fetch(`${BASE_URL}/Instapost/download/${instaId}`, {
            method: 'GET',
            headers: { Authorization: `Bearer ${token}` },
        });
        if (!response.ok) 
        {
          console.error("Failed to download Post file, status:", response.status);
          return { error: "Failed to download Post" };
        }
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = "post.pptx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error("Error downloading instapost:", error);
    }
};
  
  